var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResourcesFaQs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FAQs",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.015,
    height: 25.015,
    viewBox: "0 0 25.015 25.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19649",
    "data-name": "Path 19649",
    d: "M213.988,205.9a8.111,8.111,0,0,0-4.448-7.222,11.029,11.029,0,0,1-10.86,10.86,8.088,8.088,0,0,0,11.336,3.324l3.936,1.089-1.089-3.936a8.057,8.057,0,0,0,1.124-4.114Zm0,0",
    transform: "translate(-188.973 -188.973)",
    fill: "#7dbaab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19650",
    "data-name": "Path 19650",
    d: "M19.1,9.552A9.552,9.552,0,1,0,1.324,14.407L.035,19.068,4.7,17.779A9.553,9.553,0,0,0,19.1,9.552ZM8.086,7.329H6.62a2.931,2.931,0,1,1,4.91,2.163l-1.245,1.14v1.143H8.819V9.986L10.54,8.41a1.451,1.451,0,0,0,.477-1.082,1.466,1.466,0,1,0-2.931,0Zm.733,5.912h1.466v1.466H8.819Zm0,0",
    fill: "#7dbaab"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesFaQs);
export default __webpack_public_path__ + "static/media/Resources-FAQs.42e56ac9759a8d1dadc4dac85561c6de.svg";
export { ForwardRef as ReactComponent };